import {Loader, MantineProvider, Modal} from '@mantine/core';
import {Notifications} from '@mantine/notifications';
import {DEFAULT_NICKNAME} from '../../../../../core/entities/community/constants';
import type {CommunityTag} from '../../../../../core/entities/community/schema';
import {convertNlToBr} from '../../../../../shared/services/convertNlToBr';

export const ConfirmTopicFormModal: React.FC<{
  nickname: string;
  title: string;
  body: string;
  tags: CommunityTag[];
  opened: boolean;
  close: () => void;
  postTopicFunc: () => void;
  isPostLoading: boolean;
}> = ({
  nickname,
  title,
  body,
  tags,
  opened,
  close,
  postTopicFunc,
  isPostLoading,
}) => {
  return (
    <MantineProvider>
      <Notifications position={'top-right'} />
      <Modal
        opened={opened}
        onClose={close}
        withCloseButton={false}
        size={668}
        padding={0}
        radius={12}
        centered={true}
      >
        <div className="p-16 border-b-[1px] border-line border-collapse">
          <p className="text-md text-black-1 font-bold leading">
            以下の内容で投稿します。よろしいですか？
          </p>
        </div>
        <div className="p-24">
          <div className="pb-16 mb-24 border-b-[1px] border-line border-collapse">
            <div className="bg-background-1 p-16 rounded-4">
              <p className="text-base text-black-1 font-bold leading">投稿者</p>
              <p className="text-base text-black-1 leading mt-12">
                {nickname === '' ? DEFAULT_NICKNAME : nickname}
              </p>
            </div>
            <div className="bg-background-1 p-16 rounded-4 mt-16">
              <p className="text-base text-black-1 font-bold leading">
                タイトル
              </p>
              <p className="text-base text-black-1 leading mt-12">{title}</p>
            </div>
            <div className="bg-background-1 p-16 rounded-4 mt-16">
              <p className="text-base text-black-1 font-bold leading">タグ</p>
              <p className="text-base text-black-1 leading mt-12">
                {tags.map((tag) => tag.name).join(', ')}
              </p>
            </div>
            <div className="bg-background-1 p-16 rounded-4 mt-16">
              <p className="text-base text-black-1 font-bold leading">
                投稿内容
              </p>
              <p className="text-base text-black-1 leading mt-12">
                {convertNlToBr(body)}
              </p>
            </div>
          </div>
          <div>
            <p className="text-base text-black-1 font-bold leading">
              ご注意ください
            </p>
            <p className="text-base text-black-1 leading mt-12">
              ・トピックはほかのユーザーから見てもわかりやすいように、後から編集部でタイトルなどの修正を行う場合があります。
              <br />
              ・コメントはリアルタイムで反映されます。
              <br />
              ・不適切と判断させていただいたトピックは削除する場合があります。
              <br />
            </p>
          </div>
          <div className="mt-12">
            <p className="text-base text-black-1 font-bold leading">
              掲載できない投稿の例
            </p>
            <p className="text-base text-black-1 leading mt-12">
              ・特定の企業・法人・団体・地域・個人に対する誹謗・中傷、差別的な発言やほかのユーザーが読んで不快に感じる恐れのある内容が含まれる投稿
              <br />
              ・営業・営利目的の投稿 個人情報が特定される恐れのある投稿
              <br />
              ・他サイトやほかのユーザーの投稿のコピーなど、他者の権利を侵害する恐れのある投稿
              <br />
              ・その他編集部が不適切と判断した投稿
              <br />
            </p>
          </div>
          {isPostLoading ? (
            <div className="h-[100px] flex justify-center items-center">
              <Loader color="gray" />
            </div>
          ) : (
            <div className="mt-32 flex justify-center items-center">
              <button
                className="w-[128px] bg-black-4 py-12 px-24 text-base text-white leading font-bold rounded-full hover:opacity-80 mr-24"
                onClick={close}
              >
                キャンセル
              </button>
              <button
                className="w-[128px] bg-primary-1 py-12 px-24 text-base text-white leading font-bold rounded-full hover:opacity-80"
                onClick={postTopicFunc}
              >
                投稿する
              </button>
            </div>
          )}
        </div>
      </Modal>
    </MantineProvider>
  );
};
